__turbopack_context__.v({
  "faqBody": "_70aASa_faqBody",
  "faqIcon": "_70aASa_faqIcon",
  "faqItem": "_70aASa_faqItem",
  "faqItemInner": "_70aASa_faqItemInner",
  "faqTitle": "_70aASa_faqTitle",
  "opened": "_70aASa_opened",
});
